import * as React from 'react';
import BackToTopButton from './BackToTopButton';
import CompanyListDataGrid from './CompanyListDataGrid';

function Leaderboard({data} :any) {
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Leader Board</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Leader Board</h4>
              <p className="card-description">
                <p>We analyze all companies listed on US stock exchanges every day and rank all companies using tried and true value investing principles.
                We analyze 10 years of financial records of each company and give it a score. Below is the list of the highest-ranked companies.

                Remember to do your own research before investing in any company. Check out our guide on <a href="https://decode-investing.medium.com/how-to-identify-a-wonderful-business-6f7afdc6a5c6">How to Identify a Wonderful Business</a>.</p>
                <h5>Related:</h5>
                <ul>
                  <li><a href='/s_and_p_500'>Ranking of S&P 500 companies (Large-Cap companies)</a></li>
                  <li><a href='/s_and_p_400'>Ranking of S&P 400 (Mid-Cap companies)</a></li>
                  <li><a href='/russell_2000'>Highest ranked companies on Russell 2000 (Small-Cap companies)</a></li>
                  <li><a href='/nasdaq_100'>Ranking of Nasdaq 100 companies</a></li>
                </ul>
              </p>
              <div>
                <CompanyListDataGrid
                  data={data}
                  storageScopeKey="/leaderboard"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Leaderboard;
